module.exports = __webpack_public_path__ + "fonts/Roboto-500-latin48.665db5e.woff2";